import styled from 'styled-components'

import { Box } from '@ally/metronome-ui'

export const AccountLinkingContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
`

export const AccountLinkingContentWrapper = styled(Box)`
  ${({ theme: { media } }): string => `
    ${`${media.up('lg')} {
          width: ${(7 / 12) * 100}%; // based on a 12 column grid
      }`}
  `}
`

export const AccountLinkingStepperWrapper = styled(Box)`
  ${({ theme: { media } }): string => `
    ${media.up('lg')} {
      width: ${(5 / 12) * 100}%; // based on a 12 column grid
      order: 1;
    }
    ${media.down('lg')} {
      display: none;
    }
  `}
`
